/**
 * @since 1.0.0
 * @author ApMod Development Team
 */

import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private _isProd: boolean = environment.production;
  log(msg1: any, msg2?: any): void {
    if (!this._isProd) {
      console.log(msg1, msg2);
    }
  }
  dir(obj: any): void {
    if (!this._isProd) {
      console.dir(obj);
    }
  }
  error(msg1: any, msg2?: any): void {
    if (!this._isProd) {
      console.error(msg1, msg2);
    }
  }

  info(msg: string): void {
    if (!this._isProd) {
      console.log('info -->', msg);
    }
  }
}

